"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_contacts__or__calls(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "663f9b1b-0f9e-419f-8dd9-02c34ecf6979",
    "data-name": "calls-contacts-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "404a660c-29ef-4d5c-8cda-e63f1b55d2d1",
    x1: 112.73,
    y1: 72.73,
    x2: 183.38,
    y2: 143.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "calls-contacts-hi"), /*#__PURE__*/React.createElement("g", {
    id: "92000a76-d474-4c43-b030-55ef198a4193",
    "data-name": "Cloud_upload_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3edc3d9f-4645-442d-bbe4-af3ecef3aff2",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,24A16,16,0,0,0,24,40V152a16,16,0,0,0,16,16H144V24Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,150v2a16,16,0,0,0,16,16H144v-2H40A16,16,0,0,1,24,150Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("circle", {
    id: "2bf0f0c8-9b6e-4435-96cc-b00484aba36b",
    "data-name": "<Pfad>",
    cx: 85.02,
    cy: 76.02,
    r: 18,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    id: "49f65ce4-173e-4122-a64e-35916ce7fb48",
    "data-name": "<Pfad>",
    d: "M115,130c-3.23-21.89-16.61-36-29.82-36S58.26,108.14,55,130",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,168h8a16,16,0,0,0,16-16V132H144Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,40a16,16,0,0,0-16-16h-8V60h24Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 96.01,
    width: 24.02,
    height: 35.99,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 60.02,
    width: 24.02,
    height: 35.99,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,168h8a16,16,0,0,0,16-16V132H144Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 96.01,
    width: 24.02,
    height: 35.99,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 60.02,
    width: 24.02,
    height: 35.99,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,40a16,16,0,0,0-16-16h-8V60h24Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 130.01,
    width: 24.02,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 94.01,
    width: 24.02,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 58.02,
    width: 24.02,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.45,46.69l3.6-10H157l3.62,10h-2l-.69-2h-3.82l-.68,2ZM154.68,43h2.67L156,39Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.85,81.86v-10h3.39a3.65,3.65,0,0,1,1.79.41,2.39,2.39,0,0,1,1,1,2.85,2.85,0,0,1,.31,1.26,2.21,2.21,0,0,1-.3,1.17,2.54,2.54,0,0,1-.85.84,2.66,2.66,0,0,1,1.23.91,2.55,2.55,0,0,1,.47,1.57,2.92,2.92,0,0,1-.43,1.51,2.54,2.54,0,0,1-1.3,1.06,3.39,3.39,0,0,1-.7.18,4.78,4.78,0,0,1-.74.06Zm1.9-5.91h.93a2.69,2.69,0,0,0,1.06-.13,1.23,1.23,0,0,0,.52-.46,1.1,1.1,0,0,0-.06-1.25,1.33,1.33,0,0,0-.66-.46l-.4-.05a5.67,5.67,0,0,0-.62,0h-.78Zm0,4.2h1.37a5.23,5.23,0,0,0,.78,0,1.36,1.36,0,0,0,.46-.15,1.15,1.15,0,0,0,.46-.44A1.13,1.13,0,0,0,158,79a1.29,1.29,0,0,0-.18-.65,1.35,1.35,0,0,0-.52-.51,1.76,1.76,0,0,0-.52-.17,3.83,3.83,0,0,0-.65-.05h-1.33Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.68,117.23a4.45,4.45,0,0,1-1.73-.33,3.73,3.73,0,0,1-1.36-1,4.52,4.52,0,0,1-.89-1.62,7.25,7.25,0,0,1-.31-2.24,6.66,6.66,0,0,1,.37-2.33,4.94,4.94,0,0,1,1-1.63,3.8,3.8,0,0,1,1.37-1,4.15,4.15,0,0,1,1.58-.31,4.43,4.43,0,0,1,1.63.28,2.85,2.85,0,0,1,1.09.7,5.12,5.12,0,0,1,.61.79l-1.41,1.19a3.91,3.91,0,0,0-.22-.34A2,2,0,0,0,158,109a2.29,2.29,0,0,0-.56-.32,1.92,1.92,0,0,0-.74-.13,2,2,0,0,0-1.67.83,3.18,3.18,0,0,0-.52,1.08,5.72,5.72,0,0,0-.19,1.57,3.93,3.93,0,0,0,.7,2.51,2.29,2.29,0,0,0,1.88.88,3.39,3.39,0,0,0,1.47-.29,3.23,3.23,0,0,0,.88-.56l.62,1.67a2.54,2.54,0,0,1-.67.44,5.61,5.61,0,0,1-1.13.38A6,6,0,0,1,156.68,117.23Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.4,152.36v-10h2.82a9,9,0,0,1,1.2.09,4.59,4.59,0,0,1,1.26.36,3.79,3.79,0,0,1,1.48,1.27,4.85,4.85,0,0,1,.76,1.67,7.08,7.08,0,0,1,.2,1.56,6.17,6.17,0,0,1-.34,2,4.39,4.39,0,0,1-.91,1.58,4.17,4.17,0,0,1-1.19.92,5.36,5.36,0,0,1-2.37.51Zm1.92-1.8h.78a3.64,3.64,0,0,0,1.73-.37,2.29,2.29,0,0,0,1-1.15,4.14,4.14,0,0,0,.33-1.64,4.34,4.34,0,0,0-.3-1.61,2.47,2.47,0,0,0-.93-1.18,2.4,2.4,0,0,0-.82-.34,4.28,4.28,0,0,0-1-.11h-.82Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.14,168h-8.2l.26-126.73L168,63.95l.12,88A16,16,0,0,1,152.14,168Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#404a660c-29ef-4d5c-8cda-e63f1b55d2d1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 24.02,
    width: 2,
    height: 144,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))));
}

var _default = ic_contacts__or__calls;
exports.default = _default;